import { CONSENT_SET } from '../shared/action-names';
import { consentActionTypes } from './types';

export function consentSet(consent: {ga:boolean} | null ): consentActionTypes {
  return { type: CONSENT_SET, payload: consent };
}
